export default __webpack_public_path__ + "static/media/Crop.9572996c.svg";